<ln-icon
  *ngFor="let idx of [].constructor(showTotal ? total : value); index as i"
  name="star-fill"
  width="18px"
  height="17px"
  [class]="{ gray: i >= (focusIdx > 0 ? focusIdx : value) }"
  (mouseover)="onOver(i)"
  (click)="onClick(i)"
></ln-icon>
